import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpParams } from '@capacitor/core';
import { ApiPaginateResult } from '../apiservices/apipaginated';
import { APIService } from '../apiservices/apiservices';
import {ControleDTO} from "../formbeneficios/formbeneficios.type";

export interface IArquivoLeitura {
    idArquivo?: string;
    idLogin?: string;
    loginUsuario?: string;
    nomeUsuario?: string;
    idEmpresa?: string;
    numContrato?: string;
}

export interface IArquivoBibliotecaDTO {
  [key: string]: any;
  base64: string | void | ArrayBuffer;
  filename: string;
  descricao: string;
  titulo: string;
  idEmpresa: string;
  tipo: string;
}

@Injectable()

export class BibliotecaProvider {
  private header=APIService.getHeader();
  itemret;

  constructor(public http: HttpClient) {
  }

  criarArquivo(dto: any, isEdit = false): Promise<any> {
    var me=this;
    this.header=APIService.getHeader();

    return new Promise((resolve, reject) => {
      let url = APIService.API_URL + 'biblioteca?isEdit=' + isEdit;
      me.http.post(url, dto, {headers: this.header}).subscribe((result: any) => {
        resolve(result);
      },
      (error) => {
        reject(error);
      });
    });
  }

 get(empresa: string, titulo: string, tipoDocumento: string, dataInicio: string, dataFim: string) {
  const me = this;
  this.header = APIService.getHeader();

  return new Promise((resolve, reject) => {

    let params: string[] = [];

    if (empresa) {
      params.push(`empresa=${encodeURIComponent(empresa)}`);
    }

    if (titulo) {
      params.push(`titulo=${encodeURIComponent(titulo)}`);
    }

    if (tipoDocumento) {
      params.push(`tipodocumento=${encodeURIComponent(tipoDocumento)}`);
    }

    if (dataInicio) {
      params.push(`datainicio=${encodeURIComponent(dataInicio)}`);
    }

    if (dataFim) {
      params.push(`datafim=${encodeURIComponent(dataFim)}`);
    }

    const url = APIService.API_URL + 'biblioteca?' + params.join('&');

    me.http.get(url, { headers: this.header }).subscribe(
      (result: any) => resolve(result),
      (error) => reject(error)
    );
  });
}

  getLogVisualizacaoArquivos(titulo: string, usuario: string) {
    var me = this;
    this.header = APIService.getHeader();

    return new Promise((resolve, reject) => {
      let url = APIService.API_URL + 'biblioteca?operacao=logleitura&titulo=' + titulo + '&usuarioInclusao=' + usuario;

      me.http.get(url, {headers: this.header}).subscribe((result: any) => {
        resolve(result);
      }, (error) => {
        reject(error);
      });
    });
  }

  postLogVisualizacaoArquivos(dto: any): Promise<any> {
    var me = this;
    this.header = APIService.getHeader();

    return new Promise((resolve, reject) => {
      let url = APIService.API_URL + 'biblioteca?operacao=logleitura';
      
      me.http.post(url, dto, { headers: this.header }).subscribe((result: any) => {
        resolve(result);
      }, (error) => {
        reject(error);
      });
    });
  }

  getFile(idArquivo: string, empresa: string, titulo: string): Promise<ControleDTO<any>> {
    var me=this;
    this.header=APIService.getHeader();

    return new Promise((resolve, reject) => {
      let url = new URL(APIService.API_URL + 'biblioteca');
      url.searchParams.append('idArquivo', idArquivo);
      url.searchParams.append('empresa', empresa);
      url.searchParams.append('titulo', titulo);

      me.http.get(url.toString(), {headers: this.header}).subscribe((result: any) => {
          resolve(result);
        },
        (error) => {
          reject(error);
        });
    });
  }

  getFilesByIds(ids: string[] | number[], isDownload = null): Promise<any>
  {
    var me=this;
    this.header=APIService.getHeader();

    return new Promise((resolve, reject) => {
      let url = APIService.API_URL + 'biblioteca?operacao=arquivos&ids=' + ids.join(',');

      if(isDownload != null && typeof isDownload == "boolean")
      {
        url += '&isDownload=' + isDownload;
      }

      url += '&from=biblioteca'


      me.http.get(url, {headers: this.header}).subscribe((result: ApiPaginateResult) => {
        resolve(result);
      },
      (error) => {
        reject(error);
      });
    });
  }

  /**
   * TODO
   */
  async postLeituraArquivo(body: IArquivoLeitura): Promise<any>
  {
    var me = this;

    this.header = APIService.getHeader();

    return new Promise((resolve, reject) => {
      let url = APIService.API_URL + 'biblioteca?operacao=lido';

      me.http.post(url, body, {headers: this.header}).subscribe((result: any) => {
        resolve(result);
      },
      (error) => {
        reject(error);
      });

    });
  }

  deleteFile(id: string, empresa: string): Promise<any> {
    var me=this;
    this.header=APIService.getHeader();


    return new Promise((resolve, reject) => {
      let url = APIService.API_URL + 'biblioteca';

      me.http.delete(url, {headers: this.header, params: {
        id: id,
        empresa: empresa
      }}).subscribe((result: any) => {
        resolve(result);
      },
      (error) => {
        reject(error);
      });

    });
  }

  criarTipoArquivo(dto: any): Promise<any> {
    var me = this;
    this.header = APIService.getHeader();

    return new Promise((resolve, reject) => {
      let url = APIService.API_URL + 'tipodocumento';
      
      me.http.post(url, dto, { headers: this.header }).subscribe((result: any) => {
        resolve(result);
      }, (error) => {
        reject(error);
      });
    });
  }

  getTipoArquivo(titulo: string = null) {
    var me = this;
    this.header = APIService.getHeader();

    let path = "tipodocumento"

    if (titulo) {
      path += "?titulo=" + titulo
    }

    return new Promise((resolve, reject) => {
      let url = APIService.API_URL + path;

      me.http.get(url, { headers: this.header }).subscribe((result: any) => {
        resolve(result);
      }, (error) => {
        reject(error);
      });
    });
  }

  deletarTipoArquivo(guid: string): Promise<any> {
    var me = this;
    this.header = APIService.getHeader();

    return new Promise((resolve, reject) => {
      let url = APIService.API_URL + 'tipodocumento';

      me.http.delete(url, { headers: this.header, params: { id: guid } }).subscribe((result: any) => {
        resolve(result);
      }, (error) => {
        reject(error);
      });
    });
  }
}
